module.exports = __webpack_public_path__ + "img/arrow_drop_down.ff92d4ed.svg";